var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.33366H12.6667C13.0203 5.33366 13.3594 5.47413 13.6095 5.72418C13.8595 5.97423 14 6.31337 14 6.66699V10.667C14 11.0206 13.8595 11.3598 13.6095 11.6098C13.3594 11.8598 13.0203 12.0003 12.6667 12.0003H11.3333V14.667L8.66667 12.0003H6C5.82489 12.0005 5.65146 11.9661 5.48969 11.899C5.32792 11.832 5.18098 11.7337 5.05733 11.6097M5.05733 11.6097L7.33333 9.33366H10C10.3536 9.33366 10.6928 9.19318 10.9428 8.94313C11.1929 8.69309 11.3333 8.35395 11.3333 8.00033V4.00033C11.3333 3.6467 11.1929 3.30756 10.9428 3.05752C10.6928 2.80747 10.3536 2.66699 10 2.66699H3.33333C2.97971 2.66699 2.64057 2.80747 2.39052 3.05752C2.14048 3.30756 2 3.6467 2 4.00033V8.00033C2 8.35395 2.14048 8.69309 2.39052 8.94313C2.64057 9.19318 2.97971 9.33366 3.33333 9.33366H4.66667V12.0003L5.05733 11.6097Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.54020575.svg";
export { ForwardRef as ReactComponent };